export function withDisabledCheck(onAllowed, check, trigger) {
    return (...args) => {
        const checkResult = check(...args);
        return checkResult ? trigger(checkResult) : onAllowed(...args);
    };
}
